export const iconFontAwesomeShapesComment = (
	<i className="fa-solid fa-comment"></i>
);
